import { AlertCircle, Home, RotateCcw } from "lucide-react";
import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";
import * as Sentry from "@sentry/react";

export function ErrorBoundary() {
  const error = useRouteError() as Error;
  const navigate = useNavigate();

  useEffect(() => {
    // Log the error to your error reporting service
    console.error("Route error:", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 text-center">
      <div className="mx-auto flex max-w-[500px] flex-col items-center space-y-4">
        <AlertCircle className="size-12 text-destructive" aria-hidden="true" />
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Something went wrong
        </h1>
        <p className="text-muted-foreground">
          {error?.message ||
            "We encountered an unexpected error. Please try again."}
        </p>
        <div className="flex gap-4">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <RotateCcw className="size-4" />
            Go Back
          </Button>
          <Button onClick={() => navigate("/")} className="gap-2">
            <Home className="size-4" />
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
}
